<template>
    <div class="error-page">
        <div class="error-page__close" v-on:click="back">&lt; Back</div>
        <div class="error-page__header">{{ header }}</div>
        <div class="error-page__body">{{ msg }}</div>

        <div class="error-page__action">
            <div v-if="hasLimitBeenHit">
                <small>Please visit our website to complete your enquiry</small>
                <div class="flex">
                    <a :href="link" title="Complete booking on DesignMyNight" target="_blank">
                        Complete Booking on DesignMyNight
                    </a>
                </div>
            </div>
            <div v-else>
                <div class="flex">
                    <button class="button" v-on:click="action">
                        Try Again
                    </button>
                    <button class="button" v-on:click="book" v-if="showBookBtn">
                        Book on DesignMyNight
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'errorPage',
  props: [
    'header',
    'msg',
    'action',
    'previous',
    'showBookBtn'
  ],
  data () {
    return {
      link: '',
      hasLimitBeenHit: false
    }
  },

  methods: {
    back () {
      this.stageManager.openStage(this.previous)
    },
    book () {
      window.location.href = this.link
    }
  },

  mounted () {
    this.apiService = this.$parent.apiService
    this.enquiryManager = this.$parent.enquiryManager
    this.stageManager = this.$parent.stageManager
    this.link = this.enquiryManager.getBookingUrl(this.apiService)
    this.hasLimitBeenHit = this.apiService.ajaxFailureLimitHit()
  }
}
</script>



// WEBPACK FOOTER //
// errorPage.vue?66614bbc